<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-list-alt"></i>
        정책 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WMDS</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">정책</a>
        </li>
      </ul>
    </div>
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self">
          <label class="col-form-label" for="opt_date"> 등록 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'created_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'created_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_date">마지막 수정 날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-1" size="sm" variant="outline-primary" @click="set_sd('', 'updated_at')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'updated_at')">-1일</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'updated_at')">-1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'updated_at')">-1달</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'updated_at')">1주</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'updated_at')">1달</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_description">설명</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_description" v-model="so.opt['description']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-2">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개 이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
      </b-col>
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">정책명</span>
              </div>
              <b-form-input class="form-control" :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            </div>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7">
          </div>
          <div class="mb7 mr-2 mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7 mr-2">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="group" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.group.groupname ? row.item.group.groupname : '-'}}</del>
              <span v-else>{{row.item.group.groupname ? row.item.group.groupname : '-'}}</span>
            </template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate}}</template>
            <template slot="count" slot-scope="row">
              {{row.item.count | number}}
            </template>
            <template slot="description" slot-scope="row" v-if="row.item.policy">
              <del v-if="row.item.is_del">{{row.item.description ? row.item.description :  '-'}}</del>
              <span v-else>{{row.item.description ? row.item.description : '-'}}</span>
            </template>
            <template slot="policy" slot-scope="row" v-if="row.item.policy">{{row.item.policy.limit}}</template>
            <template slot="updated_at" slot-scope="row">{{row.item.updated_at | datetime}}</template>
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">" />
      </b-col>
      <!-- <b-col class="md-4" v-if="use_view != false">
        <div class="pull-right">
          <b-button size="sm" :limit="10" variant="success" @click="$router.push({ name: 'wmds_policy', params: { id : 'add' } })"> New registration </b-button>
        </div>
      </b-col> -->
    </b-row>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>